export const ExclusionOrders = () => {
  return (
    <div className="header-content">
      <div
        className="table-content pt-6 flex flex-col overflow-hidden"
        style={{ boxShadow: '0px 0px 25px #2F41A51F' }}
      ></div>
    </div>
  );
};
